<script setup lang="ts">
import Banner from "@/app/components/Banner.vue"
import ProgressLoader from "@/app/components/ui/ProgressLoader.vue"
import { useLogoBanner } from "@/app/composables/useLogoBanner"
import CasinoPanel from "@/casino/components/CasinoPanel.vue"
import { useCasinoData } from "@/casino/composables/useCasinoData"
import { useCasinoFilters } from "@/casino/composables/useCasinoFilters"
import { computed, ref, watch } from "vue"
import { useCasinoLobbyStore } from "../store/casinoLobby.store"

const emit = defineEmits<{
  "update:categories": [categories: any[]]
}>()

const casinoLobbyStore = useCasinoLobbyStore()
const { banners } = useLogoBanner()
const { filters, onSearch, onSort, onProviders } = useCasinoFilters()
const { categories, providers, loading, updateData } = useCasinoData(emit, casinoLobbyStore)

const expendedCategories = computed(() => {
  const defaultCategories = [
    { name: "Lobby", slug: "home", icon: "home" },
    { name: "Providers", slug: "providers", icon: "providers" },
  ]
  return [...defaultCategories, ...categories.value]
})

const casinoBanners = computed(() => {
  return banners.value.filter(b => b.type === "casino")
})

const currentPage = ref(1)
const lastPage = ref(1)

watch(() => filters.value.search, (searchValue) => {
  if (searchValue.length >= 3 || searchValue.length === 0) {
    updateData(searchValue)
  }
}, {
  immediate: true,
})
</script>

<template>
  <article class="casino-view">
    <Banner :imgs="casinoBanners" />
    <ProgressLoader :loading="loading" />
    <CasinoPanel
      :categories="expendedCategories"
      :search-value="filters.search"
      @search="onSearch"
      @providers="onProviders"
      @sort="onSort"
    />

    <RouterView
      :categories="categories"
      :providers="providers"
      :filters="filters"
      :current-page="currentPage"
      :last-page="lastPage"
      @update:data="updateData"
    />
  </article>
</template>

<style scoped>
.casino-view {
  width: 100%;
  min-height: 70vh;
}

@media screen and (max-width: 500px) {
  .casino-view {
    padding: 0 14px;
  }
}
</style>
